import React from 'react';

import { TitleBoxIcon as CompiledTitleBoxIcon } from './titleBoxComponents-compiled';

export const TitleBoxIcon = (props: any): React.JSX.Element => <CompiledTitleBoxIcon {...props} />;
